import { formatCentsForCsv } from './ordersSalesReportCsv';

export const TRANSACTIONS_REPORT_HEADERS = [
    'id',
    'data',
    'tipo',
    'categoria_saida',
    'valor',
    'desconto_taxas',
    'valor_liquido',
    'metodo_pagamento',
    'autorizacao',
    'origem',
    'descricao',
    'pedido_id',
];

const TYPE_LABELS = {
    income: 'Entrada',
    outcome: 'Saída',
};

const OUTCOME_CATEGORY_LABELS = {
    expense: 'Despesa',
    withdrawal: 'Retirada',
};

const PAYMENT_METHOD_LABELS = {
    credit_card: 'Cartão de Crédito',
    debit_card: 'Cartão de Débito',
    pix: 'PIX',
    bank_transfer: 'Transferência Bancária',
    cash: 'Dinheiro',
    other: 'Outro',
};

function escapeCsvCell(value) {
    const str = value == null ? '' : String(value);
    if (/[;"\n\r]/.test(str)) {
        return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
}

function formatTxnDate(value) {
    if (!value) {
        return '';
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return String(value);
    }
    return date.toLocaleString('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    });
}

function typeLabel(type) {
    return TYPE_LABELS[type] || type || '';
}

function outcomeCategoryLabel(transaction) {
    if (transaction?.type !== 'outcome') {
        return '';
    }
    return OUTCOME_CATEGORY_LABELS[transaction.outcome_category] || transaction.outcome_category || '';
}

function paymentMethodLabel(method) {
    return PAYMENT_METHOD_LABELS[method] || method || '';
}

export function flattenTransactionsForReport(transactions) {
    const list = Array.isArray(transactions) ? transactions : [];
    return list.map((txn) => ({
        id: txn?.id || '',
        data: formatTxnDate(txn?.created_at),
        tipo: typeLabel(txn?.type),
        categoria_saida: outcomeCategoryLabel(txn),
        valor: formatCentsForCsv(txn?.amount),
        desconto_taxas: formatCentsForCsv(txn?.deduction),
        valor_liquido: formatCentsForCsv(txn?.net_amount),
        metodo_pagamento: paymentMethodLabel(txn?.payment_method),
        autorizacao: txn?.authorization_id || '',
        origem: txn?.source || '',
        descricao: txn?.description || '',
        pedido_id: txn?.order_id || '',
    }));
}

export function buildTransactionsReportCsv(transactions) {
    const rows = flattenTransactionsForReport(transactions);
    const lines = [
        TRANSACTIONS_REPORT_HEADERS.join(';'),
        ...rows.map((row) => (
            TRANSACTIONS_REPORT_HEADERS.map((key) => escapeCsvCell(row[key])).join(';')
        )),
    ];
    return `\uFEFF${lines.join('\n')}\n`;
}

export function downloadTransactionsReportCsv(transactions, filename) {
    const csv = buildTransactionsReportCsv(transactions);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    const stamp = new Date().toISOString().slice(0, 10);
    link.href = url;
    link.download = filename || `relatorio-transacoes-${stamp}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export async function fetchAllTransactionsForReport(api, {
    q,
    from,
    to,
    type,
} = {}) {
    const limit = 100;
    let page = 1;
    let totalPages = 1;
    const items = [];

    while (page <= totalPages) {
        const params = new URLSearchParams({
            page: String(page),
            limit: String(limit),
        });
        if (q) {
            params.set('q', q);
        }
        if (from) {
            params.set('from', from);
        }
        if (to) {
            params.set('to', to);
        }
        if (type) {
            params.set('type', type);
        }

        const response = await api.get(`transactions?${params.toString()}`);
        const data = response.data?.data || response.data || {};
        const list = Array.isArray(data.transactions) ? data.transactions : [];
        items.push(...list);
        totalPages = Number(data.total_pages) || 1;
        page += 1;
        if (page > 100) {
            break;
        }
    }

    return items;
}
